export default {


    en: {
        "reports.label.reports": "Reports",
        "reports.label.name": "Name",
        "reports.label.type": "Type",
        "reports.label.category": "Category",
        "reports.label.name": "Name",
        "reports.label.outputType": "Output Type",
        "reports.label.entity": "Entity",
        "reports.label.startDate": "Start Date",
        "reports.label.endDate": "End Date",
        "reports.label.paymentMode": "Payment Mode",
        "reports.label.serialNumber": "Serial Number",
        "reports.label.yearWise": "Year Wise",
        "reports.label.runReports": "Run Reports",
        "reports.label.exportPdf": "Export PDF",
        "reports.label.exportCsv": "Export CSV",
    },


    fr: {
        "reports.label.reports": "Rapports",
        "reports.label.name": "Nom",
        "reports.label.type": "Type",
        "reports.label.category": "Catégorie",
        "reports.label.name": "Nom",
        "reports.label.outputType": "Type de sortie",
        "reports.label.entity": "Entité",
        "reports.label.startDate": "Date de début",
        "reports.label.endDate": "Date de fin",
        "reports.label.paymentMode": "Mode de paiement",
        "reports.label.serialNumber": "Numéro de série",
        "reports.label.yearWise": "Par année",
        "reports.label.runReports": "Exécuter les rapports",
        "reports.label.exportPdf": "Exporter en PDF",
        "reports.label.exportCsv": "Exporter en CSV",
    },


    es: {
        "reports.label.reports": "Informes",
        "reports.label.name": "Nombre",
        "reports.label.type": "Tipo",
        "reports.label.category": "Categoría",
        "reports.label.name": "Nombre",
        "reports.label.outputType": "Tipo de salida",
        "reports.label.entity": "Entidad",
        "reports.label.startDate": "Fecha de inicio",
        "reports.label.endDate": "Fecha de finalización",
        "reports.label.paymentMode": "Modo de pago",
        "reports.label.serialNumber": "Número de serie",
        "reports.label.yearWise": "Por año",
        "reports.label.runReports": "Ejecutar informes",
        "reports.label.exportPdf": "Exportar a PDF",
        "reports.label.exportCsv": "Exportar a CSV",
    },


    pt: {
        "reports.label.reports": "Relatórios",
        "reports.label.name": "Nome",
        "reports.label.type": "Tipo",
        "reports.label.category": "Categoria",
        "reports.label.name": "Nome",
        "reports.label.outputType": "Tipo de saída",
        "reports.label.entity": "Entidade",
        "reports.label.startDate": "Data de início",
        "reports.label.endDate": "Data de término",
        "reports.label.paymentMode": "Modo de pagamento",
        "reports.label.serialNumber": "Número de série",
        "reports.label.yearWise": "Por ano",
        "reports.label.runReports": "Executar Relatórios",
        "reports.label.exportPdf": "Exportar PDF",
        "reports.label.exportCsv": "Exportar CSV",
    },


    zh_CN: {
        "reports.label.reports": "报告",
        "reports.label.name": "名称",
        "reports.label.type": "类型",
        "reports.label.category": "类别",
        "reports.label.name": "名称",
        "reports.label.outputType": "输出类型",
        "reports.label.entity": "实体",
        "reports.label.startDate": "开始日期",
        "reports.label.endDate": "结束日期",
        "reports.label.paymentMode": "付款方式",
        "reports.label.serialNumber": "序列号",
        "reports.label.yearWise": "按年份",
        "reports.label.runReports": "运行报告",
        "reports.label.exportPdf": "导出为PDF",
        "reports.label.exportCsv": "导出为CSV",
    },


    hi: {
        "reports.label.reports": "रिपोर्टें",
        "reports.label.name": "नाम",
        "reports.label.type": "प्रकार",
        "reports.label.category": "श्रेणी",
        "reports.label.name": "नाम",
        "reports.label.outputType": "आउटपुट प्रकार",
        "reports.label.entity": "संगठन",
        "reports.label.startDate": "प्रारंभ तिथि",
        "reports.label.endDate": "समाप्ति तिथि",
        "reports.label.paymentMode": "भुगतान का माध्यम",
        "reports.label.serialNumber": "क्रमांक",
        "reports.label.yearWise": "वर्षवार",
        "reports.label.runReports": "रिपोर्ट चलाएँ",
        "reports.label.exportPdf": "पीडीएफ निर्यात करें",
        "reports.label.exportCsv": "सीएसवी निर्यात करें",
    },


    ka: {
        "reports.label.reports": "ანგარიშები",
        "reports.label.name": "სახელი",
        "reports.label.type": "ტიპი",
        "reports.label.category": "კატეგორია",
        "reports.label.name": "სახელი",
        "reports.label.outputType": "გამოსახულების ტიპი",
        "reports.label.entity": "ენთიტეტი",
        "reports.label.startDate": "დაწყების თარიღი",
        "reports.label.endDate": "დამთავრების თარიღი",
        "reports.label.paymentMode": "გადახდის რეჟიმი",
        "reports.label.serialNumber": "სერიული ნომერი",
        "reports.label.yearWise": "წლიურად",
        "reports.label.runReports": "რეპორტების გაშვება",
        "reports.label.exportPdf": "PDF ექსპორტი",
        "reports.label.exportCsv": "CSV ექსპორტი",
    },


    lo: {
        "reports.label.reports": "ບົດລາຍງານ",
        "reports.label.name": "ຊື່",
        "reports.label.type": "ປະເພດ",
        "reports.label.category": "ຫມວດ",
        "reports.label.name": "ຊື່",
        "reports.label.outputType": "ປະເພດຜົນຕາມການສ້າງ",
        "reports.label.entity": "ຕົວແທນ",
        "reports.label.startDate": "ວັນທີ່ເລີ່ມຕົ້ນ",
        "reports.label.endDate": "ວັນທີ່ສິ້ນສຸດ",
        "reports.label.paymentMode": "ຮັບເງິນໄດ້ສະຫຼຸບ",
        "reports.label.serialNumber": "ໝາຍເລກລຳດັບ",
        "reports.label.yearWise": "ປີຕົ້ນປີ",
        "reports.label.runReports": "ດໍາເນີນິດລາຍງານ",
        "reports.label.exportPdf": "ສົ່ງອອກເປັນ PDF",
        "reports.label.exportCsv": "ສົ່ງອອກເປັນ CSV",
    },


    my_MM: {
        "reports.label.reports": "အစီရင်ခံစာများ",
        "reports.label.name": "အမည်",
        "reports.label.type": "အမျိုးအစား",
        "reports.label.category": "အမျိုးအစား",
        "reports.label.name": "အမည်",
        "reports.label.outputType": "ထုတ်ဝေခန့်၏အမျိုးအစား",
        "reports.label.entity": "အဖွဲ့",
        "reports.label.startDate": "စတင်ခွဲခြားသည့်ရက်စွဲ",
        "reports.label.endDate": "အဆုံးသတ်မှတ်ချက်သည့်ရက်စွဲ",
        "reports.label.paymentMode": "ငွေပေးချေစနစ်",
        "reports.label.serialNumber": "စာရွက်စက်",
        "reports.label.yearWise": "နှစ်ခုနှစ်ခု",
        "reports.label.runReports": "အစီရင်ခံစာများကုဒ်လုပ်ပါ",
        "reports.label.exportPdf": "PDF တင်ရန်",
        "reports.label.exportCsv": "CSV တင်ရန်",
    },


    my: {
        "reports.label.reports": "အစီရင်ခံစာများ",
        "reports.label.name": "အမည်",
        "reports.label.type": "အမျိုးအစား",
        "reports.label.category": "အမျိုးအစား",
        "reports.label.name": "အမည်",
        "reports.label.outputType": "ထုတ်ဝေခန့်၏အမျိုးအစား",
        "reports.label.entity": "လုပ်ငန်း",
        "reports.label.startDate": "စတင်ခွဲခြားသည့်ရက်စွဲ",
        "reports.label.endDate": "အဆုံးသတ်မှတ်ချက်သည့်ရက်စွဲ",
        "reports.label.paymentMode": "ငွေပေးချေစနစ်",
        "reports.label.serialNumber": "စာရွက်စက်",
        "reports.label.yearWise": "နှစ်ခုနှစ်ခု",
        "reports.label.runReports": "အစီရင်ခံစာများကုဒ်လုပ်ပါ",
        "reports.label.exportPdf": "PDF တင်ရန်",
        "reports.label.exportCsv": "CSV တင်ရန်",
    },


    vi: {
        "reports.label.reports": "Báo cáo",
        "reports.label.name": "Tên",
        "reports.label.type": "Loại",
        "reports.label.category": "Danh mục",
        "reports.label.name": "Tên",
        "reports.label.outputType": "Loại đầu ra",
        "reports.label.entity": "Thực thể",
        "reports.label.startDate": "Ngày bắt đầu",
        "reports.label.endDate": "Ngày kết thúc",
        "reports.label.paymentMode": "Phương thức thanh toán",
        "reports.label.serialNumber": "Số serial",
        "reports.label.yearWise": "Theo năm",
        "reports.label.runReports": "Chạy Báo cáo",
        "reports.label.exportPdf": "Xuất PDF",
        "reports.label.exportCsv": "Xuất CSV",
    },



}